'use client';
import { useEffect } from "react";
import Link from '@/components/LocaleLink';
import { usePathname } from 'next/navigation';
import { prefixPath } from '@/hooks/useLocalePath';
import { seo } from "@/utils/seo";
import dynamic from 'next/dynamic';
import { useTranslation } from '@/contexts/TranslationContext';
const ProfileForm = dynamic(() => import('@/components/profileForm'),{ ssr: false });
import { useSessionContext } from "supertokens-auth-react/recipe/session";
const Profile = () => {
    const { t } = useTranslation();
    const pathname = usePathname();
    const session = useSessionContext();

    useEffect(() => {
        if (session.loading === false) {
            if (!session.doesSessionExist) {
                window.localStorage.removeItem('lm_main_auth');
                window.localStorage.setItem('lm_previous_path', window.location.pathname);
                window.location.href = prefixPath(pathname, '/signin');
            } else {
                console.log('Session exists:', session);
            }
        }
    }, [session]);

    useEffect(() => {
        seo(window.location.pathname);
    }, []);

    return (
        <div>
            <div className="app-content-body">
                <div className="bg-light lter b-b wrapper-md bgChange">
                    <h1 className="m-n font-thin h3">{t('members.addFamilyMember')}</h1>
                </div>

                <div className="wrapper-md">
                    <div className="section-content">
                        <div className="row">
                            <div className="col-3"></div>
                            <div className="col-6">
                                <div className="pull-right">
                                    <Link prefetch={false} href="/members/add" className="btn btn-default mt-3 me-2">{t('members.addFamilyMemberAction')}</Link>
                                    <Link prefetch={false} href="/members/view" className="btn btn-default mt-3">{t('members.viewAllFamilyMembers')}</Link>
                                </div>
                            </div>
                            <div className="col-3"></div>
                        </div>
                        <br />
                        <ProfileForm />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Profile;
